import React, { createElement, PureComponent, memo, useContext, useMemo, useState, useRef, useEffect } from 'react';
import { isUndefined, createHocRef, Provider, isPromise, RuntimeContext, isFunction, isNode, isString } from '@jupiter-app/utils';
import hoistNonReactStatic from 'hoist-non-react-statics';
import invariant from 'invariant';
import ReactDOM from 'react-dom';
export { ServerlessPrerender } from '@jupiter-app/plugin-spr';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function pluginSpecialHookHelper(_ref) {
  var _ref$plugins = _ref.plugins,
      plugins = _ref$plugins === void 0 ? [] : _ref$plugins;
  return {
    composeOnCreateApp: function composeOnCreateApp(AppComponent, config) {
      return plugins.reduce(function (_AppComponent, plugin) {
        var specialHook = plugin.__SPECIALHOOK__;
        return specialHook && specialHook.onCreateApp ? specialHook.onCreateApp(_AppComponent, config) : _AppComponent;
      }, AppComponent);
    }
  };
}
function pluginHelper(_ref2, context) {
  var plugins = _ref2.plugins;
  var bindPlugins = plugins.map(function (plugin) {
    var pluginResult = plugin(context);

    if (process.env.NODE_ENV !== 'production') {
      !!isUndefined(pluginResult.name) ? process.env.NODE_ENV !== "production" ? invariant(false, "".concat(plugin.toString(), " \n plugin must set name")) : invariant(false) : void 0;
    } // 记录已加载的插件


    context._pluginsMap[pluginResult.name] = pluginResult;
    return pluginResult;
  });
  return {
    composeProvider: function composeProvider(element, config) {
      return bindPlugins.reduce(function (ele, plugin) {
        return plugin.Provider ? plugin.Provider(ele, config) : ele;
      }, element);
    }
  };
}

var _excluded = ["store", "_loadersPromiseMap"];

function hasPluginState(plugins) {
  return plugins.some(function (plugin) {
    return plugin.__name__ === '@jupiter-app/plugin-state';
  });
}

function excludePluginRouterAndImmerIfHasReduck(hasReduck, plugins) {
  if (hasReduck) {
    return plugins.filter(function (plugin) {
      return plugin.__name__ !== '@reduck/plugin-router' && plugin.__name__ !== '@reduck/plugin-immer';
    });
  } else {
    return plugins;
  }
}

function createApp() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _config$plugins = config.plugins,
      plugins = _config$plugins === void 0 ? [] : _config$plugins,
      _config$extra = config.extra,
      extra = _config$extra === void 0 ? {} : _config$extra;
  return createHocRef(function (WrappedComponent) {
    var WithApp = /*#__PURE__*/function (_PureComponent) {
      _inherits(WithApp, _PureComponent);

      var _super = _createSuper(WithApp);

      function WithApp(props) {
        var _ssrData$data;

        var _this;

        _classCallCheck(this, WithApp);

        _this = _super.call(this, props);
        _this.appContext = null; // node ssr, first render pass [_ssrData] (_ssrData.context)
        // node ssr, second render pass [_ssrData] (_ssrData.data | _ssrData.context)
        // browser render pass [_ssrData]

        var _ssrData = props._ssrData,
            _loadersPromiseMap = props._loadersPromiseMap,
            store = props.store;
        var isHasState = hasPluginState(plugins);
        _this.appContext = {
          // the following two fields from reduck store
          extra: store && store._context && store._context.extra ? Object.assign(store._context.extra, extra) : extra,
          Plugins: store && store._context && store._context.Plugins ? store._context.Plugins : {},
          isBrowser: Boolean(true),
          _pluginHelper: null,
          _pluginsMap: {},
          _ssrData: {},
          _loaderId: 0,
          _loadersPromiseMap: // node ssr second render || node ssr first render || browser
          _ssrData && _ssrData.data && _ssrData.data.loadersData || _loadersPromiseMap || {},
          // 服务端第二次渲染 或 客户端渲染会有该值
          _storeState: _ssrData === null || _ssrData === void 0 ? void 0 : (_ssrData$data = _ssrData.data) === null || _ssrData$data === void 0 ? void 0 : _ssrData$data.storeState,
          // used to distinguish whether using @jupiter-app/plugin-state(reduck) plugin
          __RUNTIME__: isHasState ? 'pro' : 'lite'
        }; // ssr-plugin

        _ssrData && _ssrData.context && (_this.appContext._context = _ssrData && _ssrData.context);
        _this.appContext._context = _objectSpread2(_objectSpread2({}, _this.appContext._context), {}, {
          utils: {}
        }); // state-plugin

        store && (_this.appContext.store = store);
        _this.appContext._pluginHelper = pluginHelper({
          plugins: excludePluginRouterAndImmerIfHasReduck(isHasState, plugins)
        }, _this.appContext);
        return _this;
      }

      _createClass(WithApp, [{
        key: "render",
        value: function render() {
          var _this$props = this.props,
              store = _this$props.store,
              _loadersPromiseMap = _this$props._loadersPromiseMap,
              extraProps = _objectWithoutProperties(_this$props, _excluded);

          var WrappedElement = createElement(WrappedComponent, extraProps, this.props.children); // 遍历 plugin.Provider

          var root = this.appContext._pluginHelper.composeProvider(WrappedElement, _objectSpread2(_objectSpread2({}, config), this.props));

          return createElement(Provider, {
            value: this.appContext
          }, root);
        }
      }]);

      return WithApp;
    }(PureComponent); // NOTICE: if ssr, it's easy to get original WrappedComponent and configs


    WithApp.__App__ = WrappedComponent;
    WithApp.__config__ = config;
    return pluginSpecialHookHelper({
      plugins: plugins
    }).composeOnCreateApp(hoistNonReactStatic(WithApp, WrappedComponent), config);
  }, {
    // not to be hoisted
    blacklist: ['init', 'prefetch']
  });
}

function mixLoader(ary) {
  var promiseAry = ary.filter(function (promise) {
    return isPromise(promise);
  });
  var resultAry = ary.filter(function (promise) {
    return !isPromise(promise);
  });

  var _result = resultAry.reduce(function (output, promise) {
    var _result = promise._result;
    return Object.assign(output, _result);
  }, {}); // 这边可以直接将 _error 置 null，所有 error 的 loader 都是 promise


  var _data = {
    _error: null,
    _result: _result
  }; // Todo Promise.all 存在长短请求的问题，浏览器端请求应到达既放行。

  var _promise = Promise.all(promiseAry).then(function (responseArray) {
    var output = responseArray.reduce(function (output, cur) {
      // error 情况下无数据返回
      if (!cur) {
        return output;
      }

      return Object.assign(output, cur);
    }, {});
    return output;
  });

  if (resultAry.length === 0) {
    return [_promise, null];
  }

  if (promiseAry.length === 0) {
    return [_data, null];
  }

  return [_data, _promise];
}
function compose(promiseAry, setState) {
  var promise;

  if (promiseAry.length === 2) {
    var _mixLoader = mixLoader(promiseAry),
        _mixLoader2 = _slicedToArray(_mixLoader, 2),
        mixPromise = _mixLoader2[0],
        remain = _mixLoader2[1];

    promise = mixPromise;
    remain && remain.then(function (data) {
      setState(function (state) {
        return {
          _loading: false,
          _error: null,
          _data: _objectSpread2(_objectSpread2({}, state._data), data)
        };
      });
    })["catch"](function (err) {
      setState(function (state) {
        return {
          _loading: false,
          _error: err.toString(),
          _data: state._data
        };
      });
    });
  } else if (promiseAry.length === 1) {
    promise = promiseAry[0];
  }

  return promise;
}

var _excluded$1 = ["ReactforwardedRef"];
function createContainer() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var forwardRef = config.forwardRef,
      loader = config.loader,
      staticLoader = config.staticLoader,
      initProps = config.initProps;
  return createHocRef(function (WrappedComponent) {
    function WithContainerFunction(props) {
      var _context$source, _context$source2;

      var context = useContext(RuntimeContext);
      var _context = context._context;
      _context = context.isBrowser ? _context : Object.assign(_context, {
        req: (_context$source = _context.source) === null || _context$source === void 0 ? void 0 : _context$source.rawRequest,
        res: (_context$source2 = _context.source) === null || _context$source2 === void 0 ? void 0 : _context$source2.rawResponse
      });
      var initialState = useMemo(function () {
        // ssr 时需要 loader 标识
        // loader 函数标识 id，后续不会再变化
        if (loader) {
          loader._id = loader.id || loader._id || context._loaderId++;
        }

        if (staticLoader) {
          staticLoader._isStatic = true;
          staticLoader._id = staticLoader.id || staticLoader._id || context._loaderId++;
        }

        var _initialState = isFunction(initProps) ? initProps(props) : initProps || {};

        return _objectSpread2({
          _data: _initialState
        }, loader ? {
          _loading: true,
          _error: null
        } : undefined);
      }, []);

      var _useState = useState(initialState),
          _useState2 = _slicedToArray(_useState, 2),
          state = _useState2[0],
          setState = _useState2[1];

      useMemo(function () {
        if (loader || staticLoader) {
          var _context$_pluginsMap;

          var ssrReturnPlugin = (_context$_pluginsMap = context._pluginsMap) === null || _context$_pluginsMap === void 0 ? void 0 : _context$_pluginsMap['@jupiter-app/plugin-ssr'];
          var ssrPromise;
          var staticPromise;

          if (loader) {
            ssrPromise = ssrReturnPlugin && ssrReturnPlugin.onContainerLoader(loader, _objectSpread2(_objectSpread2({}, props), {}, {
              // 业务可能有使用这个 _context, 所以保留，同时增加 context字段 和 useLoader 保持一致
              _context: _context
            }), context, [{
              context: _context
            }]) || loader(props, {
              context: _context
            });
          }

          if (staticLoader) {
            staticPromise = ssrReturnPlugin && ssrReturnPlugin.onContainerLoader(staticLoader, _objectSpread2(_objectSpread2({}, props), {}, {
              // 业务可能有使用这个 _context, 所以保留，同时增加 context字段 和 useLoader 保持一致
              _context: _context
            }), context, [{
              context: _context
            }]) || staticLoader(_objectSpread2(_objectSpread2({}, props), {}, {
              context: _context
            }));
          }

          var promiseAry = [staticPromise, ssrPromise].filter(function (promise) {
            return promise;
          });
          var promise = compose(promiseAry, setState); // fist render, it is promise

          if (isPromise(promise)) {
            promise.then(function (data) {
              setState({
                _loading: false,
                _error: null,
                _data: data
              });
            })["catch"](function (err) {
              setState({
                _loading: false,
                _error: err instanceof Error ? err.toString() : err,
                _data: {}
              }); // NOTICE: whether throw error
              // throw err;
            });
          } else if (promise) {
            // node 第二次渲染数据时, 包含 loader 失败\成功的处理
            var _result = promise._result,
                _error = promise._error;
            setState({
              _loading: false,
              _data: _result || {},
              _error: _error
            });
          }
        }
      }, []);

      var ReactforwardedRef = props.ReactforwardedRef,
          extraProps = _objectWithoutProperties(props, _excluded$1);

      var WrappedElement = createElement(WrappedComponent, _objectSpread2(_objectSpread2(_objectSpread2({}, extraProps), state), {}, {
        ref: ReactforwardedRef
      }, context._context ? {
        _context: context._context
      } : undefined), props.children);
      return WrappedElement;
    }

    var MemoWithContainerFunction = memo(WithContainerFunction);
    return MemoWithContainerFunction;
  }, {
    enableRef: forwardRef
  });
}

var _ReactDOM$createRoot, _ReactDOM$unstable_cr;
var createRoot = ((_ReactDOM$createRoot = ReactDOM.createRoot) === null || _ReactDOM$createRoot === void 0 ? void 0 : _ReactDOM$createRoot.bind(ReactDOM)) || ((_ReactDOM$unstable_cr = ReactDOM.unstable_createRoot) === null || _ReactDOM$unstable_cr === void 0 ? void 0 : _ReactDOM$unstable_cr.bind(ReactDOM));
function bootstrap(AppComponment, rootElement) {
  var _window, _window$__SPECIALHOOK;

  // node ssr
  if (isNode) {
    return AppComponment;
  }

  if (isString(rootElement)) {
    rootElement = document.getElementById(rootElement);
  }

  var ssrReturnPlugin = (_window = window) === null || _window === void 0 ? void 0 : (_window$__SPECIALHOOK = _window.__SPECIALHOOK__) === null || _window$__SPECIALHOOK === void 0 ? void 0 : _window$__SPECIALHOOK['@jupiter-app/plugin-ssr'];

  if (ssrReturnPlugin !== null && ssrReturnPlugin !== void 0 && ssrReturnPlugin.onBootStrap) {
    return ssrReturnPlugin.onBootStrap(AppComponment, rootElement);
  }

  if (createRoot) {
    createRoot(rootElement).render(createElement(AppComponment));
  } else {
    ReactDOM.render(createElement(AppComponment), rootElement);
  }
}

var useMounted = function useMounted() {
  var mountedRef = useRef(true);
  useEffect(function () {
    mountedRef.current = true;
    return function () {
      mountedRef.current = false;
    };
  }, []);
  return function () {
    return mountedRef.current;
  };
};

function useLoader(loader) {
  var _initialState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var context = useContext(RuntimeContext);
  var isMounted = useMounted();
  var userInitialState = useMemo(function () {
    // ssr 时需要 loader 标识
    // loader 函数标识 id，后续不会再变化
    if (loader) {
      // id(用户传入) > _id(编译生成) > 递增序列
      loader._id = loader.id || loader._id || context._loaderId++;
    }

    return {
      data: _initialState,
      loading: true,
      error: null
    };
  }, []);
  var initialState = useMemo(function () {
    if (loader) {
      var _context$_pluginsMap;

      var ssrReturnPlugin = (_context$_pluginsMap = context._pluginsMap) === null || _context$_pluginsMap === void 0 ? void 0 : _context$_pluginsMap['@jupiter-app/plugin-ssr'];
      var promise = ssrReturnPlugin && ssrReturnPlugin.onContainerLoader(loader, {
        context: context._context
      }, context) || loader({
        context: context._context
      }); // fist render, it is promise

      if (isPromise(promise)) {
        promise.then(function (data) {
          if (isMounted()) {
            setState({
              loading: false,
              error: null,
              data: data
            });
          }
        })["catch"](function (err) {
          if (isMounted()) {
            setState({
              loading: false,
              error: err instanceof Error ? err.toString() : err,
              data: {}
            });
          } // NOTICE: whether throw error
          // throw err;

        });
        return userInitialState;
      } // node 第二次渲染数据时, 包含 loader 失败\成功的处理


      var _result = promise._result,
          _error = promise._error;
      return {
        loading: false,
        data: _result || {},
        error: _error
      };
    }

    return userInitialState;
  }, []);

  var _useState = useState(initialState),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  return state;
}

function useStaticLoader(loader) {
  var _initialState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  loader._isStatic = true;
  return useLoader(loader, _initialState);
}

function useRuntimeContext() {
  var runtimeContext = useContext(RuntimeContext);

  if (process.env.NODE_ENV !== 'production') {
    !runtimeContext ? process.env.NODE_ENV !== "production" ? invariant(false, "could not find Runtime context value; please ensure the App RootComponent is wrapped in createApp()(App). \n\n    ") : invariant(false) : void 0;
  }

  var rt = useMemo(function () {
    var _context$source, _context$source2;

    var Plugins = runtimeContext.Plugins,
        extra = runtimeContext.extra,
        store = runtimeContext.store,
        isBrowser = runtimeContext.isBrowser;

    var _context = _objectSpread2(_objectSpread2({}, runtimeContext._context), {}, {
      isBrowser: isBrowser
    });

    var _rt = {
      extra: extra,
      context: isBrowser ? _context : Object.assign(_context, {
        req: (_context$source = _context.source) === null || _context$source === void 0 ? void 0 : _context$source.rawRequest,
        res: (_context$source2 = _context.source) === null || _context$source2 === void 0 ? void 0 : _context$source2.rawResponse
      }),
      _context: _context,
      Plugins: Plugins,
      store: store
    };
    return _rt;
  }, [runtimeContext]);
  return rt;
}

var _excluded$2 = ["ReactforwardedRef"];
function withRuntimeContext() {
  var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var forwardRef = opt.forwardRef;
  return createHocRef(function (WrappedComponent) {
    function RuntimeContextComp(props) {
      var _useMemo = useMemo(function () {
        var ReactforwardedRef = props.ReactforwardedRef,
            wrapperProps = _objectWithoutProperties(props, _excluded$2);

        return [ReactforwardedRef, wrapperProps];
      }, [props]),
          _useMemo2 = _slicedToArray(_useMemo, 2),
          ReactforwardedRef = _useMemo2[0],
          wrapperProps = _useMemo2[1];

      var runtimeContext = useRuntimeContext();
      var renderedWrappedChild = useMemo(function () {
        return createElement(WrappedComponent, _objectSpread2(_objectSpread2(_objectSpread2({}, wrapperProps), runtimeContext), {}, {
          ref: ReactforwardedRef
        }));
      }, [ReactforwardedRef, WrappedComponent, runtimeContext]);
      return renderedWrappedChild;
    }

    return memo(RuntimeContextComp);
  }, {
    enableRef: forwardRef
  });
}

var _excluded$3 = ["ReactforwardedRef"];
function useRuntimeUtils() {
  var _runtimeContext$_cont;

  var runtimeContext = useContext(RuntimeContext);

  if (process.env.NODE_ENV !== 'production') {
    !runtimeContext ? process.env.NODE_ENV !== "production" ? invariant(false, "could not find Runtime context value; please ensure the App RootComponent is wrapped in createApp()(App). \n\n    ") : invariant(false) : void 0;
  }

  return (runtimeContext === null || runtimeContext === void 0 ? void 0 : (_runtimeContext$_cont = runtimeContext._context) === null || _runtimeContext$_cont === void 0 ? void 0 : _runtimeContext$_cont._utils) || {};
}
function withRuntimeUtils(opt) {
  var _ref = opt || {},
      forwardRef = _ref.forwardRef;

  return createHocRef(function (WrappedComponent) {
    function RuntimeUtilsComp(props) {
      var _useMemo = useMemo(function () {
        var ReactforwardedRef = props.ReactforwardedRef,
            wrapperProps = _objectWithoutProperties(props, _excluded$3);

        return [ReactforwardedRef, wrapperProps];
      }, [props]),
          _useMemo2 = _slicedToArray(_useMemo, 2),
          ReactforwardedRef = _useMemo2[0],
          wrapperProps = _useMemo2[1];

      var utils = useRuntimeUtils();
      var renderedWrappedChild = useMemo(function () {
        return createElement(WrappedComponent, _objectSpread2(_objectSpread2(_objectSpread2({}, wrapperProps), utils), {}, {
          ref: ReactforwardedRef
        }));
      }, [ReactforwardedRef, WrappedComponent, utils]);
      return renderedWrappedChild;
    }

    return memo(RuntimeUtilsComp);
  }, {
    enableRef: forwardRef
  });
}

var csr = false;
function NoSSR(props) {
  var _useState = useState(csr),
      _useState2 = _slicedToArray(_useState, 2),
      isMounted = _useState2[0],
      setMounted = _useState2[1];

  useEffect(function () {
    csr = true;
    setMounted(true);
  });
  return React.createElement(React.Fragment, null, isMounted ? props.children : null);
}

export { NoSSR, bootstrap, createApp, createContainer, useLoader, useRuntimeContext, useRuntimeUtils, useStaticLoader, withRuntimeContext, withRuntimeUtils };
//# sourceMappingURL=runtime.esm.js.map
